/**
 * All GraphQL queries going through AmGraphQlClient / PraGraphQlClient are cached.
 * Optional per-operation TTL overrides; everything else uses DEFAULT_QUERY_TTL_MS.
 */
export const DEFAULT_QUERY_TTL_MS = 5 * 60 * 1000;

export const QUERY_TTL_BY_OPERATION: Partial<Record<string, number>> = {
  Notifications: 60 * 1000,
};

export const getQueryTtl = (operationName: string): number =>
  QUERY_TTL_BY_OPERATION[operationName] ?? DEFAULT_QUERY_TTL_MS;

export const isApiCacheEnabled = (): boolean => process.env.REACT_APP_API_CACHE_ENABLED !== 'false';
